<template>

  <div>

    <Feed-Header v-model="currentTab"
                 :items="items"
                 :tabs="tabs">
    </Feed-Header>

    <Feed-List :paginator="paginator"
               :item="items[currentTab]"
               :is-loading="isLoading"
               :spot="spot"
               :current-tab="currentTab">
    </Feed-List>

      <button :disabled="isFetchingData" type="button" v-if="hasMoreItems" @click="fetchFeed()" class="activity-feed-load-more">
          <span v-if="isFetchingData">Loading More</span>
          <span v-else>Load More</span>
      </button>

    <Review-Popup></Review-Popup>

  </div>
</template>

<script>

import FeedHeader from './Header'
import FeedList from './List'
import ReviewPopup from './ReviewPopup'

  export default {

      components: {
          FeedList,
          FeedHeader,
          ReviewPopup,
      },

      props:['spot', 'reviewUrl'],

      data() {
          return {
              requestUrl: this.reviewUrl || `/spot/${this.spot.slug}/reviews`,
              paginator: null,
              tabs: [
                  {label: 'All', key: 'all'},
                  {label: 'Love It', key: 'loved_it'},
                  {label: 'Like It', key: 'liked_it'},
                  {label: 'Pass', key: 'pass'},
              ],
              items: {
                  all: {reviews: [], total: 0, nextUrl: null},
                  loved_it: {reviews: [], total: 0, nextUrl: null},
                  liked_it: {reviews: [], total: 0, nextUrl: null},
                  pass: {reviews: [], total: 0, nextUrl: null},
              },
              currentTab: 'all',
              isLoading: true,
              isFetchingData: false,
          }
      },

      created() {
          for (let key in this.items) {
              this.items[key].nextUrl = this.requestUrl
          }
          this.fetchFeed()
          eventBus.$on('new-review', review => {
              console.log(-1)
              for (let key in this.items) {
                  this.items[key].nextUrl = this.requestUrl
                  this.items[key].total = 0
                  this.items[key].reviews = []
              }
              this.fetchFeed()
              console.log(0)
              this.$on('spots-fetched', () => {
                  console.log(1)
                  this.$nextTick(() => {
                      console.log(2)
                      var selected = $(`#spot-review-row-${review.id}`)
                      $('html, body').animate({
                          scrollTop: selected.offset().top - 300
                      }, 2000);
                  })
              })
          })
      },

      methods: {
          fetchFeed() {
              this.isFetchingData = true
              axios.get(this.items[this.currentTab].nextUrl, {
                  params: {
                      type: this.currentTab,
                  }
              })
                  .then(response => {
                      this.paginator = response.data.paginator
                      for (let key in this.items) {
                          this.items[key].total = response.data.total[key]
                      }
                      this.items[this.currentTab].reviews =  this.items[this.currentTab].reviews.concat(response.data.paginator.data)
                      this.items[this.currentTab].nextUrl = response.data.paginator.next_page_url
                      this.isFetchingData = false
                      this.isLoading = false
                      this.$emit('spots-fetched')
                  })
                  .catch(errors => {
                      this.isFetchingData = false
                  })
          }
      },

      watch: {
          currentTab() {
              this.paginator = null
              if(this.items[this.currentTab].nextUrl != null && this.items[this.currentTab].reviews.length == 0) {
                  this.isLoading = true
              }
              if (this.hasMoreItems && this.items[this.currentTab].reviews.length == 0) {
                  this.fetchFeed()
              }
          }
      },

      computed: {
          hasMoreItems() {
              return this.items[this.currentTab].nextUrl != null
          }
      }
  }
</script>
